import React from "react";
import styled from "styled-components";
import config from "../config/app.json";


const Container = styled.div`
    width: 100%;
    padding: 0;
    background: #AC6DFD;
    position: sticky;
    top: 0;
    z-index: 10;
    min-height: 60px;
    display: flex;
    align-items: center;
    padding: 10px 0;

    .wrap{
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-right: 15px;
        padding-left: 15px;
        margin-right: auto;
        margin-left: auto;
        text-align: center;
        flex-wrap: wrap;

    }

    p,
    a {
        align-items: center;
        display: inline-flex;
        text-decoration: none;
        font-size: 0.9375rem;
        letter-spacing: 0px;
        color: #fff;
        line-height: 1.3;
        font-size: 16px;
        text-decoration: none !important;
    }
    a {
        background: url(https://www.picmaker.com/assets2/img/btn_bg.svg) center repeat-x;
        max-width: 280px;
        font-weight: 700;
        padding: 10px 15px;
        border-radius: 4px;
        -webkit-border-radius: 4px;
        margin-left: 20px;
        color: #000 !important;
    }

    .helobar_close{
    width: 24px;
    /* float: right; */
    position: absolute;
    right: 2px;
    top: 2px;
    cursor: pointer;
    }
`;


export default function HelloBar({close}) {


    return <Container>
        <div className="wrap">
    <p>
    💰 One-time payment, lifetime access: AI Social Inbox + Complete Social Suite
    </p>
    <div>
   <a target="_blank" href="https://appsumo.8odi.net/zxaeJx" >Get Lifetime Access</a>

    </div>
        </div>

        <img src="https://static.animaker.com/imagesizes/helobar_close.png" className="helobar_close" onClick={(e) => {
            e.stopPropagation();
            close();
        }}></img>
    </Container>

}